"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing = {
    borderWidth: '1px',
    input: {
        height: '3em',
        width: '17.5em',
        paddingTop: '.8em',
        paddingRight: '.7em',
        paddingBottom: '.8em',
        paddingLeft: '.7em'
    },
    inputLabel: {
        height: '1em',
        shrinkPaddingTop: '.4em',
        shrinkScale: 0.75
    },
    inputIcon: {
        width: '1em'
    }
};
exports.default = spacing;
//# sourceMappingURL=spacing.js.map